<template>
  <div>
    <v-dialog v-model="contestEntriesDialog">
      <div>
        <v-card>
          <v-card-title>
            <span class="headline">Contest Entries</span>
            <v-spacer></v-spacer>
                      <v-text-field
                        v-model="userEntrySearch"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
          </v-card-title>
            <v-data-table
              :headers="contestEntriesHeaders"
              :items="contestEntries"
              :search="userEntrySearch"
              item-key="color"
              class="elevation-10"
            >
              <template slot="items" slot-scope="props">
                <tr @click="contestEntriesDialog = true">
                  <td class="text-xs">{{ props.item.entries }}</td>
                  <td class="text-xs">{{ props.item.userId }}</td>
                  <td class="text-xs">{{ props.item.username }}</td>
                  <td class="text-xs">{{ props.item.firstName }}</td>
                  <td class="text-xs">{{ props.item.lastName }}</td>
                  <td class="text-xs">{{ props.item.mobileNumber }}</td>
                </tr>
              </template>
            </v-data-table>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeContestEntries">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="contestDrawDialog" max-width="600px">
      <div class="panel-body">
        <v-card v-if="contestDrawUser">
          <v-card-title>
            <span class="headline">Contest Draw</span>
          </v-card-title>

          <v-card-text>
            <h3
              class="headline mb-2"
            >{{ contestDrawUser.firstName + " " + contestDrawUser.lastName}}</h3>
            <div class="blue--text mb-2">{{ contestDrawUser.username }}</div>
          </v-card-text>
          <v-divider></v-divider>
          <v-layout tag="v-card-text" text-xs-left wrap>
            <v-flex tag="strong" xs5 text-xs-left mr-3 mb-2>Phone:</v-flex>
            <v-flex>{{ contestDrawUser.mobileNumber }}</v-flex>
          </v-layout>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="drawContest">Re-Draw</v-btn>
            <v-btn color="blue darken-1" text @click="saveContestDraw">Save</v-btn>
            <v-btn color="blue darken-1" text @click="closeContestDraw">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="contestList"
        :loading="loadingContests"
        item-key="id"
        class="elevation-1"
        show-expand
        :expanded.sync="contestExpanded"
      >
        <template v-slot:top>
          <v-card-title>Contest</v-card-title>
        </template>
        <template v-slot:expanded-item="{headers, item}">
          <td :colspan="headers.length">
            <v-card v-if="contestExpanded" width="100%" class="elevation-10">
              <v-data-table
                :headers="itemHeaders"
                :items="item.contestItems"
                item-key="id"
                class="elevation-10"
                show-expand
                width="100%"
                :expanded.sync="contestItemExpanded"
              >
                <template v-slot:top>
                  <v-card-title>Contest Information</v-card-title>
                </template>
                <template v-slot:expanded-item="{itemHeaders, item}">
                  <td :colspan="headers.length">
                    <v-card v-if="contestItemExpanded" width="100%" class="elevation-10">
                      <v-data-table
                        :headers="scheduleHeaders"
                        :items="item.contestSchedules"
                        item-key="color"
                        class="elevation-10"
                        width="100%"
                        sort-by="startDate"
                      >
                        <template v-slot:top>
                          <v-card-title>Contest Schedule</v-card-title>
                        </template>
                        <template slot="item" slot-scope="props">
                          <tr>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.id }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.name }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.startDate }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.endDate }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.drawDate }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.usersEnteredCount }}</td>
                            <td
                              @click="openContestEntriesDialog(props.item)"
                              class="text-xs"
                            >{{ props.item.ballotCount }}</td>
                            <td class="justify-right">
                              <v-icon small @click="openContestEntriesDialog(props.item)">visibility</v-icon>
                              <v-icon small @click="openContestDrawDialog(props.item)">attach_money</v-icon>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </td>
                </template>
              </v-data-table>
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment'
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: ['auth'],

  data: () => ({
    model: null,
    loadingContests: false,
    userEntrySearch: '',
    panel: [[true], [false], [false], [false], [false]],
    rppItems: [
      5,
      20,
      40,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 5,
    contestExpanded: [],
    contestItemExpanded: [],
    accordion: false,
    selected: [],
    contestEntriesDialog: false,
    contestEntries: [],
    contestDrawDialog: false,
    contestDrawUser: null,
    selectedScheduleId: null,
    headers: [
      {
        text: 'Contest ID',
        value: 'id'
      },
      { text: 'Name', value: 'name' },
      { text: 'Active', value: 'active' },
      { text: 'Description', value: 'description' },
      { text: 'Created Date', value: 'createdDate' }
    ],
    itemHeaders: [
      {
        text: 'Item ID',
        value: 'id'
      },
      { text: 'Name', value: 'name' },
      { text: 'Prize', value: 'prize' },
      { text: 'Bonus', value: 'bonus' },
      { text: 'Description', value: 'description' },
      { text: 'Primary', value: 'primary' },
      { text: 'Active', value: 'active' }
    ],
    scheduleHeaders: [
      {
        text: 'ID',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Name', value: 'name' },
      { text: 'Start', value: 'startDate' },
      { text: 'End', value: 'endDate' },
      { text: 'Draw', value: 'drawDate' },
      { text: 'Users', value: 'usersEnteredCount' },
      { text: 'Ballots', value: 'ballotCount' },
      { text: '', value: '', align: 'end', sortable: false }
    ],
    contestEntriesHeaders: [
      {
        text: 'Entries',
        align: 'left',
        value: 'entries',
        filterable: false
      },
      { text: 'User Id', value: 'userId' },
      { text: 'Username', value: 'username' },
      { text: 'First Name', value: 'firstName' },
      { text: 'Last Name', value: 'lastName' },
      { text: 'Mobile Number', value: 'mobileNumber' }
    ],
    contestList: [],
    editedIndex: -1,
    editedItem: {
      userId: '',
      reason: 0,
      udpatedDate: 0,
      createdDate: 0
    },
    defaultItem: {
      userId: '',
      reason: 0,
      udpatedDate: 0,
      createdDate: 0
    }
  }),

  components: {},

  computed: {},

  watch: {
    contestEntriesDialog (val) {
      val || this.closeContestEntries()
    },
    contestDrawDialog (val) {
      val || this.closeContestDraw()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    async initialize () {
      this.loadingContests = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_REWARDS}/contests`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.contestList = getResponse.data
      this.loadingContests = false
    },

    async openContestEntriesDialog (scheduleItem) {
      this.loadingContestEntries = true
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_REWARDS
      }/contest-schedule/${scheduleItem.id}/entries`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.contestEntries = getResponse.data
      this.loadingContestEntries = false
      this.contestEntriesDialog = true
    },

    async openContestDrawDialog (scheduleItem) {
      this.selectedScheduleId = scheduleItem.id
      this.drawContest()
      this.contestDrawDialog = true
    },

    async drawContest () {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_REWARDS
      }/contest-schedule/${this.selectedScheduleId}/draw`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })

      this.contestDrawUser = getResponse.data
    },

    closeContestEntries () {
      this.contestEntriesDialog = false
    },

    closeContestDraw () {
      this.contestDrawDialog = false
      this.selectedScheduleId = null
    },

    async saveContestDraw () {
      var endpoint = `${
        process.env.VUE_APP_QUBER_SERVICE_REWARDS
      }/contest/user-entry`
      // console.log(this.contestDrawUser)
      var getResponse = await rh.default
        .post(endpoint, this.contestDrawUser, true)
        .catch(e => {
          this.errors.push(e)
        })

      this.closeContestDraw()
    }
  }
}
</script>
